import type { FC, MouseEventHandler } from 'react';
import { memo, useCallback, useMemo, useState } from 'react';
import type { OffsetOptions, Placement } from '@floating-ui/react';
import type { BlockEnum, OnSelectBlock } from '../types';
// import Tabs from './tabs';
import {
  PortalToFollowElem,
  PortalToFollowElemContent,
  PortalToFollowElemTrigger,
} from '@/components/base/portal-to-follow-elem';
import { Input, Space, Button } from 'antd';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';


type EdgeEditorProps = {
  open?: boolean;
  initVal?: string;
  onOpenChange?: (open: boolean) => void;
  onOk: (value: string) => void;
  trigger?: (open: boolean) => React.ReactNode;
  placement?: Placement;
  offset?: OffsetOptions;
  triggerStyle?: React.CSSProperties;
  triggerClassName?: (open: boolean) => string;
  triggerInnerClassName?: string;
  popupClassName?: string;
  asChild?: boolean;
  availableBlocksTypes?: BlockEnum[];
  disabled?: boolean;
  noBlocks?: boolean;
};
const EdgeEditor: FC<EdgeEditorProps> = ({
  open: openFromProps,
  initVal = '',
  onOpenChange,
  onOk,
  trigger,
  placement = 'right',
  offset = 6,
  triggerClassName,
  triggerInnerClassName,
  triggerStyle,
  popupClassName,
  asChild,
  disabled,
}) => {
  const [labelText, setLabelText] = useState(initVal);
  const [localOpen, setLocalOpen] = useState(false);
  const open = openFromProps === undefined ? localOpen : openFromProps;
  const handleOpenChange = useCallback(
    (newOpen: boolean) => {
      setLocalOpen(newOpen);

      if (!newOpen) setLabelText('');
      if(newOpen) setLabelText(initVal)

      if (onOpenChange) onOpenChange(newOpen);
    },
    [onOpenChange, initVal],
  );
  const handleTrigger = useCallback<MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if (disabled) return;
      e.stopPropagation();
      handleOpenChange(!open);
    },
    [handleOpenChange, open, disabled],
  );

  const handleOk = useCallback(
    (value) => {
      handleOpenChange(false);
      onOk(value);
    },
    [handleOpenChange, onOk],
  );


  return (
    <PortalToFollowElem
      placement={placement}
      offset={offset}
      open={open}
      onOpenChange={handleOpenChange}
    >
      <PortalToFollowElemTrigger
        asChild={asChild}
        onClick={handleTrigger}
        className={triggerInnerClassName}
      >
        {trigger ? (
          trigger(open)
        ) : (
          <div
            className={`
                  z-10 flex h-4 
                  w-4 cursor-pointer items-center justify-center rounded-full bg-components-button-primary-bg text-text-primary-on-surface hover:bg-components-button-primary-bg-hover
                  ${triggerClassName?.(open)}
                `}
            style={triggerStyle}
          >
            <EditOutlined style={{ fontSize: '10px', fontWeight: 'bolder' }} className="h-2.5 w-2.5" />
          </div>
        )}
      </PortalToFollowElemTrigger>
      <PortalToFollowElemContent className="z-[1000]">
        <div
          className={`rounded-lg border-[0.5px] border-gray-200 bg-white shadow-lg ${popupClassName}`}
        >
          <div className="p-2" onClick={(e) => e.stopPropagation()}>
            <Space direction="horizontal">
              <Input
                allowClear
                autoFocus
                value={labelText}
                placeholder="编辑标签"
                onChange={(e: any) => setLabelText(e.target.value || '')}
              />
              <Button type='primary' onClick={() => handleOk(labelText)}>
                确认
              </Button>
            </Space>
          </div>
        </div>
      </PortalToFollowElemContent>
    </PortalToFollowElem>
  );
};

export default memo(EdgeEditor);
